export default __webpack_public_path__ + "static/media/Blog12.628be4a9.png";